<template>
    <div>
        <el-form-item prop="name" label="组件名称：" label-width="110px">
            {{field.name + '组件'}}
        </el-form-item>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

  export default {
    name: 'tms-type-module-name',
    props: {
      field: {
        type: [Object, Array],
        required: true
      },
      config: {
        type: Object,
        default() {
          return {}
        }
      }
    },

    computed: {
      required() {
        if (this.field.required) {
          return 'is-required'
        } else {
          return '';
        }
      }
    },

    data() {
      return {

      }
    },

    created() {
    },

    components: {},

    mounted() {

    },

    methods: {}
  }

</script>
